import clsx from 'clsx';
import { ComponentPropsWithoutRef, FC, forwardRef } from 'react';
import { RegistryPaginationControlsProps } from './registry-pagination-controls';
import { RegistryPaginationCounterProps } from './registry-pagination-counter';
import { RegistryPaginationLimitSelectProps } from './registry-pagination-limit-select';

export type RegistryPaginationProps = ComponentPropsWithoutRef<'div'>;

export const createRegistryPagination = (
	RegistryPaginationLimitSelect: FC<RegistryPaginationLimitSelectProps>,
	RegistryPaginationCounter: FC<RegistryPaginationCounterProps>,
	RegistryPaginationControls: FC<RegistryPaginationControlsProps>,
) => {
	const RegistryPagination = forwardRef<HTMLDivElement, RegistryPaginationProps>(
		({ className, children, ...props }, ref) => (
			<div
				ref={ref}
				className={clsx('registry-pagination', className)}
				{...props}
			>
				{children ?? (
					<>
						<RegistryPaginationLimitSelect />
						<RegistryPaginationCounter />
						<RegistryPaginationControls />
					</>
				)}
			</div>
		),
	);

	return RegistryPagination;
};
